export default __webpack_public_path__ + "static/media/e-filing-picturemark-d.4036bd33.svg";